export enum Roles {
  ADMIN = 'admin',
  COMPANY = 'company',
  MANAGER = 'manager',
  EDITOR = 'editor',
  INSTRUCTOR = 'instructor',
  TRAINING_COMPANY_MANAGER = 'training-company-manager',
  TRAINEE = 'trainee'
}
